import React from "react";

export default function LoadingButton({ children, isLoading, onClick, className, dotColor = "#fff", type = "button" }) {
  return (
    <button 
      type={type}
      className={`${className} ${isLoading ? "loading" : ""}`}
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading ? (
        <>
          <span className="text-light">Loading</span>
          <span className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </>
      ) : (
        children
      )}
    </button>
  )
}
